import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateContact } from "../hooks";
import { ContactForm } from "../components";

export const CreateContact: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  const { form, submit, loading } = useCreateContact({
    defaultValues: {
      customerId: customerId ? +customerId : undefined,
      isPrimary: false,
      active: true,
    },
    onCompleted: () => {
      toast.success("Le contact a été créé avec succès");
      if (customerId) {
        navigate(`/customer/${customerId}`);
      }
    },
  });

  return (
    <>
      <Header
        title="Contact"
        subtitle="Créer un nouveau contact"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/contacts`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau contact" />
          <ContactForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
